import React from 'react';
import { RotateCcw } from 'lucide-react';
interface ResetFiltersButtonProps {
  /** True when at least one filter differs from its default */
  isActive: boolean;
  onReset: () => void;
  /** Defaults to "Reset filters" for filter rows. */
  label?: string;
  className?: string;
}

/**
 * Shared "Reset filters" control. Always visible so filter rows keep a stable
 * layout, and disabled until a filter has actually been changed.
 */
export function ResetFiltersButton({
  isActive,
  onReset,
  label = 'Reset filters',
  className = ''
}: ResetFiltersButtonProps) {
  return <button type="button" onClick={onReset} disabled={!isActive} className={`flex w-full items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#30718D] transition-colors hover:bg-[#30718D]/10 focus:outline-none focus:ring-2 focus:ring-[#30718D] disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent sm:w-auto ${className}`} data-id="element-2005" data-mp="30piyqu4148z9">
      <RotateCcw size={15} aria-hidden="true" data-id="element-2006" data-mp="c4rdvbfyvvaa" />
      {label}
    </button>;
}